// src/portals/creator/components/OpportunityCard.js
import React from "react";
import Card from "../../../components/ui/Card";
import Button from "../../../components/ui/Button";

const OpportunityCard = ({ opp }) => {
  return (
    <Card className="p-4 mb-3">
      <p className="text-xs font-semibold text-primary">
        {opp.type || "Opportunity"}
      </p>
      <p className="font-bold text-slate-800 mt-1 truncate">
        {opp.advertiser || opp.brand}
      </p>
      <p className="text-sm text-slate-500 mt-1 truncate">
        {opp.campaign || opp.offer}
      </p>
      {opp.revenueShare && (
        <p className="text-xs text-slate-500 mt-2">
          Rev Share:{" "}
          <span className="font-medium text-slate-600">{opp.revenueShare}</span>
        </p>
      )}
      {/* ✨ This container now stacks buttons on mobile and places them in a row on sm+ screens */}
      <div className="flex flex-col sm:flex-row sm:justify-end sm:space-x-2 mt-4 space-y-2 sm:space-y-0">
        <Button variant="ghost" size="sm" className="w-full sm:w-auto">
          Decline
        </Button>
        <Button variant="secondary" size="sm" className="w-full sm:w-auto">
          Accept
        </Button>
      </div>
    </Card>
  );
};

export default OpportunityCard;
